import React, { useEffect, useState } from 'react';
import Header from '../components/resuableComponents/Header';
import Footer from '../components/resuableComponents/Footer';
import { AutoComplete, Divider } from 'antd';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useDispatch, useSelector } from 'react-redux';
import { Box, Container, Grid } from '@mui/material';
import Checkbox from '@mui/material/Checkbox';
import { DatePicker, Space } from 'antd';
import { Modal } from 'antd';
import type { DatePickerProps } from 'antd';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import Skeleton from '@mui/material/Skeleton';
import { Button } from 'antd';
import {
	fetchCityDispatch,
	AddSearchFlightDispatch,
} from '../reducers/HomeReducer';
import { useLocation, useNavigate } from 'react-router-dom';
import FlightResultSkeleton from '../components/resuableComponents/FlightResultSkeleton';
import TopDrawer from '../components/resuableComponents/TopDrawer';
import Navbar from '../components/resuableComponents/Navbar/Navbar';
const Option = AutoComplete.Option;
const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const SearchResultPage = () => {
	const { city } = useSelector((state) => state.home);
	const { tboflight, loading } = useSelector((state) => state.tbo);
	const { etravresult } = useSelector((state) => state.etrav);
	const { tjkresult } = useSelector((state) => state.tripjack);
	const dispatch = useDispatch();
	const [departDate, setDepartDate] = useState('');
	const [draw, setDraw] = useState(false);
	const [loadings, setLoading] = useState(false);
	const [open, setOpen] = useState(false);
	const [scrollVal, SetScrollVal] = useState(10);
	const [hasMorefilterData, SethasMoreFilterData] = useState(true);
	const navigate = useNavigate();
	const location = useLocation();
	console.log('location', location);
	const onChange: DatePickerProps['onChange'] = (date, dateString) => {
		console.log(date, dateString);
		setDepartDate(dateString);
	};
	const showModal = () => {
		setOpen(true);
	};

	const handleOk = () => {
		setLoading(true);
		setTimeout(() => {
			setLoading(false);
			setOpen(false);
		}, 3000);
	};

	const handleCancel = () => {
		setOpen(false);
	};
	const fetchMoreData = () => {
		// if (eltbo === fals && letrav === false && trp === false) {
		// 	if (scrollVal >= filterData.length) {
		// 		SethasMoreFilterData(false);
		// 	}
		// }

		setTimeout(() => {
			SetScrollVal(scrollVal + 5);
		}, 500);
	};
	const opsList =
		city?.result?.length > 0 &&
		city.result?.map((l) => {
			return (
				<Option
					value={`${l.airport_code} - ${l.city_name}`}>{`${l.airport_code} - ${l.city_name} , ${l.country_name}`}</Option>
			);
		});
	const handleChange = (value) => {
		let values = value.toLowerCase();
		let cityData = {
			keywords: values,
			limits: 10,
		};
		dispatch(fetchCityDispatch(cityData));
	};
	useEffect(() => {
		dispatch(AddSearchFlightDispatch(location.state));
	}, []);
	let combineflightData = [];
	let filterData = [];
	let filterAirlineTBO = [];

	if (loading) {
		console.log('Loading');
	} else {
		let tbo =
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0 &&
			tboflight?.result?.Response?.Results[0];
		let etrav =
			etravresult &&
			etravresult?.result &&
			etravresult?.result?.TripDetails[0]?.Flights;
		let tjk =
			tjkresult &&
			tjkresult?.result?.searchResult &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD?.length > 0 &&
			tjkresult?.result?.searchResult?.tripInfos?.ONWARD;
		console.log('etravh', etrav);
		if (tbo?.length > 0 && etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...etrav, ...tjk];
		} else if (tbo?.length > 0 && etrav?.length > 0) {
			combineflightData = [...tbo, ...etrav];
		} else if (tbo?.length > 0 && tjk?.length > 0) {
			combineflightData = [...tbo, ...tjk];
		} else if (etrav?.length > 0 && tjk?.length > 0) {
			combineflightData = [...etrav, ...tjk];
		} else if (etrav?.length > 0 && tbo?.length > 0) {
			combineflightData = [...etrav, ...tbo];
		} else if (tbo?.length > 0) {
			combineflightData = [...tbo];
		} else if (etrav?.length > 0) {
			combineflightData = [...etrav];
		} else if (tjk?.length > 0) {
			combineflightData = [...tjk];
		}
		filterData =
			combineflightData &&
			combineflightData.length > 0 &&
			combineflightData.slice().sort((a, b) => {
				let first =
					a.Supplier === 'TBO'
						? Number(
								Number(Math.round(a.Fare.Total_Amount)) -
									Number(Math.round(a.Fare.MFB_Discount))
						  )
						: a.Supplier === 'ETR'
						? Number(Math.round(a.Fares.Total_Amount))
						: a.Supplier === 'TJK'
						? Number(Math.round(a.totalPriceList.fd.Total_Amount))
						: '';
				let second =
					b.Supplier === 'TBO'
						? Number(
								Number(Math.round(b.Fare.Total_Amount)) -
									Number(Math.round(b.Fare.MFB_Discount))
						  )
						: b.Supplier === 'ETR'
						? Number(Math.round(b.Fares.Total_Amount))
						: b.Supplier === 'TJK'
						? Number(Math.round(b.totalPriceList.fd.Total_Amount))
						: '';
				return first - second;
			});
		if (
			tboflight &&
			tboflight?.result &&
			tboflight?.result?.Response &&
			tboflight?.result?.Response?.Results[0].length > 0
		) {
			filterAirlineTBO = [
				...new Set(
					tboflight &&
						tboflight?.result &&
						tboflight?.result?.Response &&
						tboflight?.result?.Response?.Results[0].length > 0 &&
						tboflight?.result?.Response?.Results[0].map(
							(item) => item.Segments[0]?.[0]?.Airline.AirlineName
						)
				),
			];
		}
	}
	console.log('FilterData', filterData);
	console.log('filterAirlineTBO', filterAirlineTBO);
	return (
		<div>
			<Navbar />
			{filterData?.length > 0 ? (
				<Box style={{ background: '#721053' }}>
					<Box
						style={{
							paddingLeft: 100,
							paddingRight: 100,
							paddingTop: 15,
							paddingBottom: 15,
						}}>
						<Grid container spacing={2}>
							<Grid item xs={3}>
								<AutoComplete
									style={{ width: '100%', borderRadius: 2 }}
									dropdownMenuStyle={{
										maxHeight: 1000,
										overflowY: 'visible',
										maxWidth: 500,
									}}
									placeholder='From'
									onChange={handleChange}>
									{opsList}
								</AutoComplete>
							</Grid>
							<Grid item xs={3}>
								<AutoComplete
									style={{ width: '100%', borderRadius: 2 }}
									dropdownMenuStyle={{
										maxHeight: 1000,
										overflowY: 'visible',
										maxWidth: 500,
									}}
									placeholder='From'
									onChange={handleChange}>
									{opsList}
								</AutoComplete>
							</Grid>
							<Grid item xs={2}>
								<DatePicker
									onChange={onChange}
									style={{ width: '100%', padding: 8 }}
								/>
							</Grid>{' '}
							<Grid item xs={2}>
								<Button
									onClick={showModal}
									style={{
										textTransform: 'capitalize',
										padding: 7,
										border: '1px solid lightgrey',
										width: '100%',
										height: 'auto',
									}}>
									Traveller Class
								</Button>{' '}
								<Modal
									open={open}
									title='Travellers'
									onOk={handleOk}
									onCancel={handleCancel}
									footer={[
										<Button key='back' onClick={handleCancel}>
											OK
										</Button>,
									]}>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<p>Adults(12+yrs)</p>
										<Box>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
												}}>
												5
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<p>Child(2-11yrs)</p>
										<Box>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
												}}>
												5
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												+
											</Button>
										</Box>
									</Box>
									<Box
										style={{
											display: 'flex',
											justifyContent: 'space-between',
										}}>
										<p>Infant(0-2yrs)</p>
										<Box>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												--
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'white',
												}}>
												5
											</Button>
											<Button
												style={{
													fontSize: 14,
													background: 'orange',
													color: 'white',
												}}>
												+
											</Button>
										</Box>
									</Box>
								</Modal>
							</Grid>
							<Grid item xs={2}>
								<Button
									style={{
										background: '#EC5B24',
										color: 'white',
										width: '100%',
										padding: 7,
										height: 'auto',
									}}>
									Search
								</Button>
							</Grid>
						</Grid>
					</Box>
				</Box>
			) : (
				<div className='horizontal-bar-wrap' style={{}}>
					<div className='bar1 bar'></div>
				</div>
			)}
			{filterData?.length > 0 ? (
				<Box
					style={{
						background: '#FFF',
						boxShadow: '0 0 10px rgba(0,0,0,.3)',
						paddingLeft: 100,
						paddingRight: 100,
						paddingTop: 10,
					}}>
					<Grid container spacing={2}>
						<Grid item xs={3}>
							<Box>
								<span>Stops</span>
							</Box>
							<Box style={{ display: 'flex' }}>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Non-Stop</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>1 Stop</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>1+Stop</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={4}>
							<Box>
								<span>Airline</span>
							</Box>
							<Box style={{ display: 'flex', flexWrap: 'wrap' }}>
								{filterAirlineTBO.map((i, index) => {
									return index < 4 ? (
										<Box style={{ display: 'flex', alignItems: 'center' }}>
											<Checkbox {...label} size='small' />
											<span style={{ fontSize: 12 }}>{i}</span>
										</Box>
									) : (
										''
									);
								})}
							</Box>
						</Grid>
						<Grid item xs={3}>
							<Box>
								<span>Fare Type</span>
							</Box>
							<Box style={{ display: 'flex' }}>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Refundable</span>
								</Box>
								<Box style={{ display: 'flex', alignItems: 'center' }}>
									<Checkbox {...label} />
									<span style={{ fontSize: 12 }}>Non-Refundable</span>
								</Box>
							</Box>
						</Grid>
						<Grid item xs={2}>
							<Box
								style={{
									display: 'flex',
									alignItems: 'center',
									cursor: 'pointer',
								}}
								onClick={() => setDraw(true)}>
								More <i class='fa fa-angle-down' style={{ marginLeft: 5 }}></i>
							</Box>
						</Grid>
					</Grid>
				</Box>
			) : (
				''
			)}
			<Box
				style={{
					marginTop: 50,
					marginBottom: 50,
					paddingLeft: 100,
					paddingRight: 100,
				}}>
				<Grid container spacing={4}>
					<Grid item xs={12} lg={8}>
						<Box
							style={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
							}}>
							<h2 style={{ fontSize: 26 }}>{`Flight From ${
								location.state.Segments[0].Origin
							} to ${location.state.Segments[0].Destination}(${
								filterData?.length ? filterData?.length : ''
							})`}</h2>
							<h3 style={{ fontSize: 20 }}>
								{location.state.Segments[0].PreferredDepartureTime}
							</h3>
						</Box>
						{filterData?.length > 0 ? (
							<InfiniteScroll
								dataLength={scrollVal}
								next={fetchMoreData}
								hasMore={hasMorefilterData}
								loader={<h4 style={{ textAlign: 'center' }}>Loading...</h4>}
								endMessage={
									<p style={{ textAlign: 'center' }}>
										<b>No More Flights</b>
									</p>
								}>
								{filterData?.map((item, index) => {
									return index < scrollVal ? (
										<>
											<Box
												style={{
													display: 'flex',
													justifyContent: 'space-between',
													alignItems: 'center',
													borderRadius: 4,
													background: '#fff',
													filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
													padding: 30,
													marginTop: 10,
												}}>
												<Box>
													<img
														src={`https://nitish.musafirbazar.com/static/media/${
															item.Supplier === 'TBO'
																? item.AirlineCode
																: item.Supplier === 'ETR'
																? item.Airline_Code
																: item.Supplier === 'TJK'
																? item.sI[0].fD.aI.code
																: ''
														}.gif`}
														style={{ height: 50 }}
													/>
													<br></br>
													<span
														style={{ color: 'rgba(0,0,0,.38)', fontSize: 12 }}>
														{item.Supplier === 'TBO'
															? item.Segments[0].slice(0, 1).map((i) => {
																	return i.Airline.AirlineName;
															  })
															: item.Supplier === 'ETR'
															? item.Segments[0].Airline_Name
															: item.Supplier === 'TJK'
															? item.sI[0].fD.aI.name
															: ''}
													</span>
													<br></br>
													<span
														style={{ color: 'rgba(0,0,0,.38)', fontSize: 12 }}>
														{`${
															item.Supplier === 'TBO'
																? item.AirlineCode
																: item.Supplier === 'ETR'
																? item.Segments[0].Airline_Code
																: item.Supplier === 'TJK'
																? item.sI[0].fD.aI.code
																: ''
														}${
															item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Airline.FlightNumber;
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Flight_Number
																: item.Supplier === 'TJK'
																? item.sI[0].fD.fN
																: ''
														}`}
													</span>
												</Box>

												<Box>
													<span
														style={{ fontSize: 14, color: 'rgba(0,0,0,.38)' }}>
														{item.Supplier === 'TBO'
															? item.FareRules[0].Origin
															: item.Supplier === 'ETR'
															? item.Origin
															: item.Supplier === 'TJK'
															? item.sI[0].da.code
															: ''}
													</span>
													<br></br>
													<span style={{ fontSize: 26 }}>
														{item.Supplier === 'TBO'
															? item.Segments[0].slice(0, 1).map((i) => {
																	return i.Origin.DepTime.substr(11, 5);
															  })
															: item.Supplier === 'ETR'
															? item.Segments[0].Departure_DateTime.split(
																	' '
															  )[1]
															: item.Supplier === 'TJK'
															? item.sI[0].dt.substr(11, 5)
															: ''}
													</span>
													<br></br>
													<span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														{/* Tue, 15 Aug */}
														{`${new Date(
															item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Origin.DepTime.split('T')[0];
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Departure_DateTime.split(
																		' '
																  )[0]
																: item.Supplier === 'TJK'
																? item.sI[0].dt.split('T')[0]
																: ''
														).toLocaleString('en-us', {
															weekday: 'short',
														})} ,  ${new Date(
															item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Origin.DepTime.split('T')[0];
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Departure_DateTime.split(
																		' '
																  )[0]
																: item.Supplier === 'TJK'
																? item.sI[0].dt.split('T')[0]
																: ''
														).getDate()} ${new Date(
															item.Supplier === 'TBO'
																? item.Segments[0].slice(0, 1).map((i) => {
																		return i.Origin.DepTime.split('T')[0];
																  })
																: item.Supplier === 'ETR'
																? item.Segments[0].Departure_DateTime.split(
																		' '
																  )[0]
																: item.Supplier === 'TJK'
																? item.sI[0].dt.split('T')[0]
																: ''
														).toLocaleString('en-us', {
															month: 'short',
														})}`}
													</span>
													<br></br>
													{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
												</Box>
												<Box textAlign={'center'}>
													<span
														style={{ fontSize: 14, color: 'rgba(0,0,0,.38)' }}>
														2hr 15min
													</span>
													<br></br>
													<span>-------------------</span>
													<br></br>

													<span>
														{item.Supplier === 'TBO'
															? item.Segments[0].length === 1
																? 'Non Stop'
																: item.Segments[0].length === 2
																? '1 Stop'
																: item.Segments[0].length === 3
																? '2 Stop'
																: ''
															: item.Supplier === 'ETR'
															? item.Segments.length === 1
																? 'Non Stop'
																: item.Segments.length === 2
																? '1 Stop'
																: item.Segments.length === 3
																? '2 Stop'
																: ''
															: item.Supplier === 'TJK'
															? item.sI.length === 1
																? 'Non Stop'
																: item.sI.length === 2
																? '1 Stop'
																: item.sI.length === 3
																? '2 Stop'
																: ''
															: ''}
													</span>
												</Box>
												<Box>
													<span
														style={{ fontSize: 14, color: 'rgba(0,0,0,.38)' }}>
														{item.Supplier === 'TBO'
															? item.Segments[0].length == 2
																? item.Segments[0]
																		.filter((i, index) => index === 1)
																		.map((it) => {
																			return it.Destination.Airport.AirportCode;
																		})
																: item.Segments[0].length == 3
																? item.Segments[0]
																		.filter((i, index) => index === 2)
																		.map((it) => {
																			return it.Destination.Airport.AirportCode;
																		})
																: item.Segments[0].length == 1
																? item.Segments[0].map((it) => {
																		return it.Destination.Airport.AirportCode;
																  })
																: ''
															: item.Supplier === 'ETR'
															? item.Destination
															: item.Supplier === 'TJK'
															? item.sI.length === 1
																? item.sI
																		.filter((i, index) => index === 0)
																		.map((it) => {
																			return it.aa.cityCode;
																		})
																: item.sI.length === 2
																? item.sI
																		.filter((i, index) => index === 1)
																		.map((it) => {
																			return it.aa.cityCode;
																		})
																: item.sI.length === 3
																? item.sI
																		.filter((i, index) => index === 2)
																		.map((it) => {
																			return it.aa.cityCode;
																		})
																: ''
															: ''}
													</span>
													<br></br>
													<span style={{ fontSize: 26 }}>
														{item.AirlineCode
															? item.Segments[0].length == 3
																? item.Segments[0]
																		.filter((i, index) => index === 2)
																		.map((i) => {
																			return i.Destination.ArrTime.substr(
																				11,
																				5
																			);
																		})
																: item.Segments[0].length == 2
																? item.Segments[0]
																		.filter((i, index) => index === 1)
																		.map((i) => {
																			return i.Destination.ArrTime.substr(
																				11,
																				5
																			);
																		})
																: item.Segments[0].length == 1
																? item.Segments[0]
																		.filter((i, index) => index === 0)
																		.map((i) => {
																			return i.Destination.ArrTime.substr(
																				11,
																				5
																			);
																		})
																: ''
															: item.Supplier === 'ETR'
															? item.Segments.length === 1
																? item.Segments.filter(
																		(i, index) => index === 0
																  ).map((it) => {
																		return it.Arrival_DateTime.substr(11, 5);
																  })
																: item.Segments.length === 2
																? item.Segments.filter(
																		(i, index) => index === 1
																  ).map((it) => {
																		return it.Arrival_DateTime.substr(11, 5);
																  })
																: item.Segments.length === 3
																? item.Segments.filter(
																		(i, index) => index === 2
																  ).map((it) => {
																		return it.Arrival_DateTime.substr(11, 5);
																  })
																: ''
															: item.Supplier === 'TJK'
															? item.sI.length === 1
																? item.sI
																		.filter((i, index) => index === 0)
																		.map((it) => {
																			return it.at.substr(11, 5);
																		})
																: item.sI.length === 2
																? item.sI
																		.filter((i, index) => index === 1)
																		.map((it) => {
																			return it.at.substr(11, 5);
																		})
																: item.sI.length === 3
																? item.sI
																		.filter((i, index) => index === 2)
																		.map((it) => {
																			return it.at.substr(11, 5);
																		})
																: ''
															: ''}{' '}
													</span>
													<br></br>
													<span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														{`${new Date(
															item.AirlineCode
																? item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? item.Segments.filter(
																			(i, index) => index === 0
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 2
																	? item.Segments.filter(
																			(i, index) => index === 1
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 3
																	? item.Segments.filter(
																			(i, index) => index === 2
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: ''
																: ''
														).toLocaleString('en-us', {
															weekday: 'short',
														})} ,  ${new Date(
															item.AirlineCode
																? item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? item.Segments.filter(
																			(i, index) => index === 0
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 2
																	? item.Segments.filter(
																			(i, index) => index === 1
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 3
																	? item.Segments.filter(
																			(i, index) => index === 2
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: ''
																: ''
														).getDate()} ${new Date(
															item.AirlineCode
																? item.Segments[0].length == 3
																	? item.Segments[0]
																			.filter((i, index) => index === 2)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 2
																	? item.Segments[0]
																			.filter((i, index) => index === 1)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: item.Segments[0].length == 1
																	? item.Segments[0]
																			.filter((i, index) => index === 0)
																			.map((i) => {
																				return i.Destination.ArrTime.split(
																					'T'
																				)[0];
																			})
																	: ''
																: item.Supplier === 'ETR'
																? item.Segments.length === 1
																	? item.Segments.filter(
																			(i, index) => index === 0
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 2
																	? item.Segments.filter(
																			(i, index) => index === 1
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: item.Segments.length === 3
																	? item.Segments.filter(
																			(i, index) => index === 2
																	  ).map((it) => {
																			return it.Arrival_DateTime.split(' ')[0];
																	  })
																	: ''
																: item.Supplier === 'TJK'
																? item.sI.length === 1
																	? item.sI
																			.filter((i, index) => index === 0)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 2
																	? item.sI
																			.filter((i, index) => index === 1)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: item.sI.length === 3
																	? item.sI
																			.filter((i, index) => index === 2)
																			.map((it) => {
																				return it.at.split('T')[0];
																			})
																	: ''
																: ''
														).toLocaleString('en-us', {
															month: 'short',
														})}`}
													</span>
													<br></br>
													{/* <span
														style={{ fontSize: 12, color: 'rgba(0,0,0,.38)' }}>
														Mumbai
													</span> */}
												</Box>
												<h2>
													₹
													{item.Supplier === 'TBO'
														? Number(
																Math.round(
																	Number(
																		Number(Math.round(item.Fare.Total_Amount)) -
																			Number(Math.round(item.Fare.MFB_Discount))
																	)
																)
														  )
														: item.Supplier === 'ETR'
														? Number(
																Math.round(
																	Number(
																		Number(Math.round(item.Fares.Total_Amount))
																	)
																)
														  )
														: item.Supplier === 'TJK'
														? Number(
																Math.round(
																	Number(
																		Number(
																			Math.round(
																				item.totalPriceList.fd.Total_Amount
																			)
																		)
																	)
																)
														  )
														: ''}
												</h2>
												<Button
													onClick={() =>
														navigate('/flightbooking', {
															state: { onward: item, formData: location.state },
														})
													}
													style={{
														background: '#EC5B24',
														color: 'white',
														width: '18%',
													}}>
													Book
												</Button>
											</Box>
											{/* <Box
												style={{
													alignItems: 'center',
													borderRadius: 4,
													background: '#fff',
													// filter: 'drop-shadow(0 2px 4px rgba(0, 0, 0, .25))',
												}}>
												<span>Flight Details</span>
											</Box> */}
										</>
									) : (
										''
									);
								})}
							</InfiniteScroll>
						) : (
							Array.from(Array(10)).map((i) => {
								return <FlightResultSkeleton />;
							})
						)}
					</Grid>
					<Grid item xs={12} lg={4}>
						<Box>
							<img src='https://tpc.googlesyndication.com/simgad/16156858053234787891?sqp=4sqPyQQrQikqJwhfEAEdAAC0QiABKAEwCTgDQPCTCUgAUAFYAWBfcAJ4AcUBLbKdPg&rs=AOga4qmd7sh5rWiWjxdzaN9vw44WnXQdZA' />
						</Box>
					</Grid>
				</Grid>
			</Box>
			<TopDrawer
				draw={draw}
				setDraw={setDraw}
				filterAirlineTBO={filterAirlineTBO}
			/>
			<Footer />
		</div>
	);
};

export default SearchResultPage;
